import { render, staticRenderFns } from "./formPhone.vue?vue&type=template&id=43cd30fc"
import script from "./formPhone.vue?vue&type=script&lang=js"
export * from "./formPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports